import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGermany = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_198_9118)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0.62207 13.4779C2.035 17.2859 5.70043 19.9997 10.0001 19.9997C14.2997 19.9997 17.9652 17.2859 19.3781 13.4779L10.0001 12.6084L0.62207 13.4779Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.0001 0C5.70043 0 2.035 2.71375 0.62207 6.52176L10.0001 7.39129L19.3781 6.52172C17.9652 2.71375 14.2997 0 10.0001 0Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.621992 6.52148C0.220039 7.6048 0 8.77652 0 9.99973C0 11.2229 0.220039 12.3946 0.621992 13.478H19.378C19.78 12.3946 20 11.2229 20 9.99973C20 8.77652 19.78 7.6048 19.378 6.52148H0.621992Z",
					fill: "#D80027"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_9118",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGermany);
export { ForwardRef as ReactComponent };
